<template>
    <el-dialog :title="title" :visible.sync="visible" width="45%" :before-close="handleClose">
        <div class="importDialogCenter">
            <div class="centerItem leftItem" @click="downloadTemplate">
                <i class="el-icon-download avatar-uploader-icon"></i>
                <p class="itemText">{{ downloadText }}</p>
            </div>
            <div class="centerItem">
                <el-upload
                    class="upload-demo"
                    drag
                    :on-error="handleUploadError"
                    :on-success="handleUploadSuccess"
                    :action="uploadAction"
                    :headers="headers"
                    :data="uploadData"
                    :show-file-list="false"
                    :accept="accept"
                    :before-upload="handleBeforeUpload"
                >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" style="text-align: center" slot="tip">支持拓展名：{{ accept }}</div>
                </el-upload>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="handleClose">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    name: 'ImportDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        // 对话框标题
        title: {
            type: String,
            default: '导入'
        },
        // 上传接口地址（完整URL或相对路径）
        uploadUrl: {
            type: String,
            default: ''
        },
        // 下载模板接口地址（完整URL或相对路径）
        downloadUrl: {
            type: String,
            default: ''
        },
        // 下载文件名
        downloadFileName: {
            type: String,
            default: '导入模板.xlsx'
        },
        // 下载按钮文本
        downloadText: {
            type: String,
            default: '点击下载模板'
        },
        // 上传额外数据
        uploadData: {
            type: Object,
            default: () => ({})
        },
        // 接受的文件类型
        accept: {
            type: String,
            default: '.xlsx'
        },
        // 是否显示下载模板按钮
        showDownload: {
            type: Boolean,
            default: true
        },
        // 是否显示上传区域
        showUpload: {
            type: Boolean,
            default: true
        },
        // 自定义headers
        customHeaders: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            headers: {}
        };
    },
    computed: {
        uploadAction() {
            if (this.uploadUrl) {
                return this.uploadUrl.startsWith('http') ? this.uploadUrl : this.$baseURL + this.uploadUrl;
            }
            return this.$baseURL + 'import';
        }
    },
    mounted() {
        this.initHeaders();
    },
    watch: {
        visible(val) {
            if (val) {
                this.initHeaders();
            }
        }
    },
    methods: {
        initHeaders() {
            let token = sessionStorage.getItem('userToken');
            this.headers = {
                Authorization: 'Bearer ' + token,
                ...this.customHeaders
            };
        },
        handleClose() {
            this.$load.close();
            this.$emit('update:visible', false);
            this.$emit('close');
        },
        handleBeforeUpload() {
            this.$load.show();
            return true;
        },
        handleUploadError(error) {
            this.$load.close();
            this.$message.error('上传失败');
            this.$emit('upload-error', error);
        },
        handleUploadSuccess(response) {
            this.$load.close();
            if (response.code == 2000||response.code == 2001) {
                this.$messageShow(response)
                this.$emit('upload-success', response.data);
                this.handleClose();
            } else {
                this.$messageShow(response)
                this.$emit('upload-fail', response);
            }
        },
        downloadTemplate() {
            if (!this.downloadUrl) {
                this.$message.warning('未配置下载地址');
                return;
            }
            
            const url = this.downloadUrl.startsWith('http') ? this.downloadUrl : this.$baseURL + this.downloadUrl;
            const token = sessionStorage.getItem('userToken');
            
            this.$axios
                .get(url, {
                    params: {
                        token: token,
                        ...this.uploadData
                    },
                    responseType: 'arraybuffer'
                })
                .then(response => {
                    let blob = new Blob([response.data]);
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = this.downloadFileName;
                    link.click();
                })
                .catch(() => {
                    this.$message.error('下载失败');
                    this.$emit('download-error');
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.importDialogCenter {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    .centerItem {
        width: 48%;
        text-align: center;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        &:hover {
            border-color: #409eff;
        }
        ::v-deep .el-upload--text {
            width: 100%;
        }
        ::v-deep .el-upload-dragger {
            width: 100%;
        }
    }
    .leftItem {
        width: 48%;
        height: 180px;
        cursor: pointer;
        box-sizing: border-box;
        position: relative;
        border-radius: 8px;
        border: 1px dashed #97a8be;
        .itemText {
            position: absolute;
            top: 70%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    line-height: 178px;
    text-align: center;
}
</style>
